import { Component, OnInit, NgZone } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '../../../../_services/translate.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var $: any;
import { AnpiService } from '../../../../_services/anpi-code.service';
import { AuthenticationService } from '../../../../_services/authentication.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  login: any;
  url: any;
  isBusiness = false;
  accountDetails: any;
  currentValue: any;
  loginStatus:any;
  constructor(private ngZone: NgZone,
    private router: Router,
    private translate: TranslateService,
    private formBuilder: FormBuilder,
    private anpiService: AnpiService,
    private authenticationService: AuthenticationService) {

    const data = localStorage.getItem('currentUserDetails');

     if (data) {
      this.accountDetails = JSON.parse(data);
      if (this.accountDetails && this.accountDetails.current_user == 1) {
        this.login = this.accountDetails.current_user;


      } else if (this.accountDetails && this.accountDetails.current_user == 2) {
        this.loginStatus = this.accountDetails.login_status;
        if (this.loginStatus == 1) {
          this.login = this.accountDetails.current_user;
        }

      }
      if (this.accountDetails.GNI == "1") {
        this.isBusiness = true;
      }
    }
    // this.anpiService.changeEvent.subscribe(() => {
    //   console.log("ASdsadsasadsadsadasdsadasdsadsd")
    //   this.currentValue = this.authenticationService.currentUserValue;
    //   if (!this.currentValue) {
    //     this.isBusiness = false;
    //     this.accountDetails = '';
    //   }
    // });
  }

  ngOnInit() {
    this.ngZone.run(() => {
      this.url = window.location.pathname.split('/')[1];
    });


  }

  getCnamgs() {
    console.log("39")
    if (this.accountDetails.cnamgs == 1) {
      this.router.navigate(['/cnamgs-reportlist']);
    } else {
      this.router.navigate(['/cnamgs-report']);
    }
  }

  getCnamgsemployee() {
    this.router.navigate(['/cnss/cnamgs'], { state: { data: 'cnamgs' } });
  }

}
